import React from 'react'

/**
 * Formats field names into a readable string with bolded field names
 * @param fieldNames Array of field names to format
 * @returns JSX element with formatted field names
 *
 * @example
 * formatFieldNamesContent(['Title', 'Body']) => <><b>Title</b> and <b>Body</b> fields</>
 * formatFieldNamesContent(['Title']) => <><b>Title</b> field</>
 * formatFieldNamesContent(['Title', 'Body', 'Image']) => <><b>Title</b>, <b>Body</b>, and <b>Image</b> fields</>
 */
export function formatFieldNamesContent(fieldNames: string[]): React.ReactElement {
    if (fieldNames.length === 0) {
        return <span>fields</span>
    }

    if (fieldNames.length === 1) {
        return (
            <>
                <b>{fieldNames[0]}</b> field
            </>
        )
    }

    // Multiple fields: "Field1, Field2, and Field3 fields"
    return (
        <>
            {fieldNames.slice(0, -1).map((name, index) => (
                <React.Fragment key={name}>
                    <b>{name}</b>
                    {index < fieldNames.length - 2 ? ', ' : ''}
                </React.Fragment>
            ))}
            {', and '}
            <b>{fieldNames[fieldNames.length - 1]}</b> fields
        </>
    )
}
